import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CorpoPagina from '../../../Componentes/CorpoPagina';
import DateInput from '../../../Componentes/DateInput';
import Espaçador from '../../../Componentes/Espaçador';
import ModalView, { ModalTópico } from '../../../Componentes/ModalView';
import SelectInput from '../../../Componentes/SelectInput';
import TabelaComponente from '../../../Componentes/TabelaComponente';
import TopicoTexto from '../../../Componentes/TopicoTexto';
import { StoreContexto } from '../../../Contexto/Provider';
import { apiService } from '../../../Services/ApiService';
import ModalConfirmacao from '../../../Componentes/ModalConfirmacao';
import CheckBoxOpcoes from '../../../Componentes/CheckBoxOpcoes';
import BotaoDuplo from '../../../Componentes/BotaoDuplo';
import { useTranslation } from 'react-i18next';
import '../../../Estilos/Fontes.css';

export default function ListaAlertas() {
  const [alerts, setAlerts] = useState([]);
  const [totalAlerts, setTotalAlerts] = useState(0);
  const [alert, setAlert] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [filters, setFilters] = useState({
    origin: { label: 'Geral', value: 'ALL' },
    environment: {},
    variable: { label: 'Geral', value: 'ALL' },
    date: '',
  });

  const [filtersOptions, setFiltersOptions] = useState({
    origin: [
      { label: 'Geral', value: 'ALL' },
      { label: 'Ambiente', value: 'ENVIRONMENT' },
      { label: 'Geladeira', value: 'REFRIGERATOR' },
    ],
    environment: [],
    variable: [
      { label: 'Geral', value: 'ALL' },
      { label: 'Temperatura', value: 'TEMPERATURE' },
      { label: 'Umidade', value: 'HUMIDITY' },
      { label: 'Porta aberta', value: 'END_OF_COURSE' },
    ],
  });

  const [page, setPage] = useState(0);

  const [menuOptions, setMenuOptions] = useState(['Visualizar']);

  const [modalVisible, setModalVisible] = useState(false);
  const [modalConfirm, setModalConfirm] = useState({
    visible: false,
    message: '',
    operation: '',
    id: '',
  });
  const [modalError, setModalError] = useState({
    visible: false,
    message: '',
  });

  const [alertNature, setAlertNature] = useState([
    { value: 'AIR_CURTAIN_DISABLED', nome: 'Cortina de ar fora de funcionamento', state: false },
    { value: 'DEHUMIDIFIER_DISABLED', nome: 'Desumidificador fora de funcionamento', state: false },
    { value: 'ENERGY_DISABLED', nome: 'Falta de energia elétrica', state: false },
    { value: 'ENVIRONMENT_OPEN', nome: 'Forro de ambiente aberto', state: false },
    {
      value: 'COOLER_DISABLED',
      nome: 'Máquina de refrigeração fora de funcionamento',
      state: false,
    },
    {
      value: 'REFRIGERATOR_DOOR_OPEN',
      nome: 'Porta da geladeira aberta acima do tempo permitido',
      state: false,
    },
    { value: 'ENVIRONMENT_DOOR_OPEN', nome: 'Porta do ambiente aberta', state: false },
    { value: 'NA', nome: 'N/A', state: false },
  ]);

  const [alertDescription, setAlertDescription] = useState('');

  const [alertNatureForm, setAlertNatureForm] = useState({
    nature: '',
    description: '',
  });

  const navigate = useNavigate();
  const { get, post } = apiService();
  const { auth } = useContext(StoreContexto);
  const { t: tVar } = useTranslation('variables');
  const { t: tFilters } = useTranslation('filters');

  useEffect(() => {
    getAlerts();
  }, [page, filters]);

  useEffect(() => {
    if (auth.perfilSalvo === 'OWNER') {
      setMenuOptions(['Visualizar']);
    }
  }, [auth]);

  const getAlerts = async () => {
    const activeFilters = Object.entries(filters)
      .filter(([key, value]) => value.value)
      .reduce((acc, [key, value]) => {
        acc[key] = value.value;
        return acc;
      }, {});

    const queryParams = { page, size: 10, ...activeFilters };

    if (filters.date) {
      queryParams.date = new Date(filters.date).toISOString().split('T')[0];
    }

    const getVariableUnit = (variable) => {
      switch (variable) {
        case 'TEMPERATURE':
          return '°C';
        case 'HUMIDITY':
          return '%';
        case 'END_OF_COURSE':
          return 's';
        default:
          return '';
      }
    };

    setIsLoading(true);
    try {
      const response = await get('alerts', queryParams);
      const result = response.result.map((alert) => {
        const unit = getVariableUnit(alert.variable);
        alert.variableName = tVar(alert.variable);
        alert.date = new Date(alert.createdAt).toLocaleDateString();
        alert.createdAtAndFinishedAt = `${new Date(alert.createdAt).toLocaleTimeString()}`;
        alert.outOfRangeValues = `${Number(alert.value).toFixed(2)}${unit} (${
          alert.minValue
        }${unit} a ${alert.maxValue}${unit})`;
        alert.environmentName = alert.environment.name || '';
        if (alert.finishedAt) {
          alert.createdAtAndFinishedAt += ` ~ ${new Date(alert.finishedAt).toLocaleTimeString()}`;
        }
        return alert;
      });

      setAlerts(result || []);
      setTotalAlerts(response.count || 0);
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao buscar alertas' });
    } finally {
      setIsLoading(false);
    }
  };

  const getAlertById = async (id) => {
    setIsLoading(true);
    try {
      const response = await get(`alerts/${id}`);
      setAlert(response);
      setAlertNatureForm({ nature: response.nature, description: response.description });
      setAlertNature(
        alertNature.map((alert) => {
          alert.state = alert.value === response.nature;
          return alert;
        }),
      );
      setAlertDescription(response.description);
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao buscar alerta' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilter = async (filter, txt) => {
    let newFilters = { ...filters };
    newFilters[filter] = txt;
    setFilters(newFilters);
  };

  const handleMenuItemSelect = async (id, item) => {
    if (item === 'Visualizar') {
      navigate(`/alert-form/${id}`);
    }
  };

  const handleEditClick = async (id) => {
    await getAlertById(id);
    setModalVisible(true);
  };

  const handleCheckBoxChange = (txt) => {
    const newAlertNature = alertNature.map((alert) => {
      if (alert.value === txt) {
        alert.state = !alert.state;
      } else {
        alert.state = false;
      }
      return alert;
    });

    setAlertNature(newAlertNature);
  };

  const handleDescriptionChange = (txt) => {
    setAlertDescription(txt);
  };

  const handleConfirm = async (hasConfirmed) => {
    if (!hasConfirmed) {
      setModalVisible(false);
      return;
    }

    await saveAlertNature();
  };

  const saveAlertNature = async () => {
    setIsLoading(true);
    const alertNatureSelected = alertNature.find((alert) => alert.state);
    const alertData = { nature: alertNatureSelected.value, description: alertDescription };

    try {
      await post(`alerts/nature/${alert.id}`, alertData);
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao salvar alerta' });
    } finally {
      setModalVisible(false);
      getAlerts();
    }
  };

  const enableSaveButton = () => {
    if (alertNatureForm.nature) {
      return false;
    }
    if (!alertNature.find((alert) => alert.state)) {
      return false;
    }
    if (!alertDescription) {
      return false;
    }

    return true;
  };

  const nextPage = async () => {
    setPage(page + 1);
  };

  const previousPage = async () => {
    setPage(page - 1);
  };

  return (
    <CorpoPagina loading={isLoading}>
      {modalError.visible && (
        <ModalConfirmacao
          aviso={modalError.message}
          erro={true}
          clicado={() => setModalError({ visible: false, message: '' })}
        />
      )}

      {modalConfirm.visible && (
        <ModalConfirmacao
          aviso={modalConfirm.message}
          confirmar={false}
          clicado={() => {
            setUserDisabled(modalConfirm.id);
            setModalConfirm({ visible: false, message: '', operation: '', id: '' });
          }}
          clicadoVolta={() =>
            setModalConfirm({ visible: false, message: '', operation: '', id: '' })
          }
        />
      )}

      {modalVisible && (
        <ModalView height={'100%'} width={'100%'}>
          <ModalTópico titulo="Alertas" />
          <CheckBoxOpcoes
            titulo="Natureza"
            items={alertNature}
            top={8}
            width="92%"
            altura="250px"
            clicado={(txt) => handleCheckBoxChange(txt)}
            multiple={false}
            disabled={alertNatureForm.nature ? true : false}
          />
          <textarea
            style={{
              fontFamily: 'montserrat',
              fontSize: 16,
              width: 450,
              height: 100,
              borderRadius: 5,
              border: '1px solid #005288',
              padding: 8,
              resize: 'none',
              marginBottom: 16,
            }}
            placeholder="Descreva em 200 caracteres"
            maxLength={200}
            onChange={(e) => handleDescriptionChange(e.target.value)}
            value={alertDescription}
            disabled={alertNatureForm.description ? true : false}
          />
          <BotaoDuplo
            externo
            clicado={() => handleConfirm(true)}
            clicadoVolta={() => handleConfirm(false)}
            nome="Salvar"
            nomeVolta="Cancelar"
            disabled={!enableSaveButton()}
          />
        </ModalView>
      )}

      <div className="ContainerGeral">
        <TopicoTexto titulo="Lista de Alertas" altura={50} />
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'row',
            alignItems: 'center',
            marginTop: 48,
            marginBottom: 16,
          }}
        >
          <SelectInput
            titulo="Filtrar"
            padrao={filters.origin}
            itens={filtersOptions.origin}
            largura={254}
            clicado={(txt) => handleFilter('origin', txt)}
          />
          <Espaçador espaço={16} />
          <SelectInput
            titulo="Variável"
            padrao={filters.variable}
            itens={filtersOptions.variable}
            largura={254}
            clicado={(txt) => handleFilter('variable', txt)}
          />
          <Espaçador espaço={16} />
          <DateInput titulo="Data" largura={254} top={9} clicado={(d) => handleFilter('date', d)} />
        </div>
        <TabelaComponente
          colunas={[
            'LOCALIZAÇÃO',
            'ID',
            'VARIÁVEL',
            'VALOR FORA DO PARÂMETRO',
            'DATA',
            'INÍCIO E FIM',
          ]}
          campos={[
            'environmentName',
            'endnodeId',
            'variableName',
            'outOfRangeValues',
            'date',
            'createdAtAndFinishedAt',
          ]}
          linhas={alerts}
          paginaAtual={page}
          total={totalAlerts}
          aviso={!alerts.length ? 'Nenhum alerta encontrado' : 'Buscando alertas...'}
          menuOptions={menuOptions}
          onMenuItemSelect={handleMenuItemSelect}
          onEditClick={(id) => handleEditClick(id)}
          goToNextPage={() => nextPage()}
          goToPreviousPage={() => previousPage()}
          entity="alerts"
          role={auth.perfilSalvo}
        />
      </div>
    </CorpoPagina>
  );
}
